/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

export const TITLE_CLICK = 'MobileResultsHeader:titleClick'

class MobileResultsHeader {
  constructor (element) {
    this.$el = $(element)

    this.$el.find('.mobileResultsHeader-button').on('click', () => {
      this.$el.trigger(TITLE_CLICK)
    })
  }
}

registerClass('MobileResultsHeader', MobileResultsHeader)
